import { DotsSixVerticalIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Drag = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <DotsSixVerticalIcon {...rest} size={Sizes[size]} color={fill} />;
};

Drag.displayName = 'Drag';
